import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController } from 'ionic-angular';
import { DatePickerDirective } from 'ion-datepicker';
import { MeetteamProvider } from '../../../providers/meetteam/meetteam';
import { MeetteamDetailsPage } from './meet-details/meet-details';
import {CreateLunch} from "./create-lunch/create-lunch";
import {CreateVisio} from "./create-visio/create-visio";

/**
 * Generated class for the LunchroulettePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-lunchroulette',
  templateUrl: 'lunchroulette.html',
})
export class LunchroulettePage {

  searchQuery = '';

  // Datepicker vars
  @ViewChild(DatePickerDirective) public datepicker: DatePickerDirective;
  public localDate: Date = new Date();
  public initDate: Date = new Date();
  public min: Date = new Date();
  //---------

  meetType: number = -1;
  meetProps: any = {
    type: this.meetType,
    multiple: false,
    date: null
  }
  //
  createOutput : any = {
    created: false,
    match: false,
    id: '',
    coming: 0,
  }
  // Pendings
  pendingMeetteams: any = null;
  comingMeetteam: any = null;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public meetProvider: MeetteamProvider,
              public modalCtrl: ModalController) {
  }

  ionViewDidLoad() {
    this.resetView();
  }


  ngOnInit() {
    this.loadMeetteams();
  }

  loadMeetteams() {
        // Loads pending/coming meetteams
        this.meetProvider.getAll().subscribe((res) => {
          if(res.success){
            this.pendingMeetteams = res.data;
            this.pendingMeetteams.forEach(currMeet => {
              // Check and store the closest meet
              if(Math.round((new Date(currMeet.lunchroulette_date.split('/').reverse()).getTime() - new Date().getTime()) / (1000 * 3600 * 24)) > 0){
                 this.comingMeetteam = currMeet
              }else{
                currMeet['expired'] = true;
              }
            });
          }
        })
  }

  joinLunchRoulette(){
    this.meetProps.type = this.meetType;
    this.meetProvider.create(this.meetProps).subscribe((res) => {
      if(res.success){
        this.createOutput.created = true;
        this.createOutput.match = res.data.full;
        this.createOutput.id = res.data.id;
        this.createOutput.coming = res.data.count;
      }
    })
  }

  checkMeet(id){
    let modalMeet = this.modalCtrl.create(MeetteamDetailsPage, {meetId: id});
    modalMeet.present().then(() => {});
  }

  resetView(){
    this.meetProps.type = -1;
    this.meetProps.date = null;
    this.meetProps.multiple = false;
    this.createOutput = {
      created: false,
      match: false,
      id: '',
      coming: 0,
    };
    this.meetType = -1;
    this.loadMeetteams();
  }

  isDateExpired(date){
    return new Date().toLocaleDateString() > new Date(date.split('/').reverse().join('-')).toLocaleDateString()
  }





  selectedDateFormat(e){
    this.meetProps.date = e.toLocaleDateString();
  }


  public Log(stuff): void {
    this.datepicker.open();
    this.datepicker.changed.subscribe(() => console.log('test'));
  }

  public event(data: Date): void {
    this.localDate = data;
  }
  setDate(date: Date) {
    this.initDate = date;
  }

  goToCreateLunch() {
    let modalView = this.modalCtrl.create(CreateLunch) 
    modalView.onDidDismiss(() => {
      this.loadMeetteams();
    })
    modalView.present().then(() => {});
  }

  goToCreateVisio() {
    let modalView = this.modalCtrl.create(CreateVisio)
    modalView.onDidDismiss(() => {
      this.loadMeetteams();
    })
    modalView.present().then(() => {});
  }

}



// WEBPACK FOOTER //
// ./src/pages/employee/lunchroulette/lunchroulette.ts